// extracted by mini-css-extract-plugin
export default {"root":"BarChart_root__pimwj","text-small":"BarChart_text-small__hplbK"};